import React from 'react';
import { Query } from 'react-apollo';
import ValuationTile from '../components/Succession/ValuationTile';
import gql from 'graphql-tag';

const GET_PRACTICE_VALUATION = gql`
  query GetPracticeValuation {
    practiceValuation
    getCurrentUser {
      id
      gross_production
      recurring_revenue
      assets_under_management
      number_of_clients
    }
  }
`;

const ValuationTileContainer = ({ current_user }) => {
  // Add debugging to trace the user data
  console.log('ValuationTileContainer current_user:', current_user);
  
  return (
    <Query query={GET_PRACTICE_VALUATION}>
      {({ loading, error, data }) => {
        if (loading) {
          console.log('Loading valuation data...');
          return <div>Loading...</div>;
        }
        
        if (error) {
          console.error('Error loading valuation data:', error);
          return <div>Error loading valuation data</div>;
        }

        console.log('Valuation data received:', data);
        const valuation = data?.practiceValuation || 0;
        // Merge the user data from props with the data from GraphQL
        const userData = {
          ...current_user,
          ...data.getCurrentUser
        };
        console.log('Combined user data:', userData);
        
        return <ValuationTile valuation={valuation} user={userData} />;
      }}
    </Query>
  );
};

export default ValuationTileContainer; 